<template>
    <Tooltip  
            theme="light"
            v-if="tipsVisibility==true" 
            :content="tipsProperty.content" 
            :placement="tipsProperty.placement" 
            transfer>
        <Icon type="information-circled"></Icon>
        <div slot="content" v-show="tipsProperty.contentList.length>0" v-for="item in tipsProperty.contentList" >
            <span :style="styles(item)">{{item.content}}</span>
        </div>
    </Tooltip  > 

</template>
<style>
.ivu-tooltip-inner {
    background-color: white;
    border: 1px solid #96C8DA;
    color: black
}
.ivu-tooltip-popper[x-placement^=top] .ivu-tooltip-arrow {
    border-top-color: #96C8DA;
}

</style>

<script>
export default {
  name: "",
  components:{},
  props:{
      //是否显示
      tipsVisibility:{
        type: Boolean,
        default: false
      },  
      //tip的属性
      tipsProperty: [Object],
  },
  data() {
    return {

    };
  },
  computed: {
    
  },
  methods: {
      styles (item) {
        let style = {};

        if (item.fontSize) {
            style['font-size'] = `${item.fontSize}px`;
        }

        if (item.color) {
            style.color = item.color;
        }

        return style;
    }
  },
  mounted() {
  }
};
</script>




// WEBPACK FOOTER //
// src/components/common/table/plug/headTips.vue